import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from 'api/models';
import { UsersStore } from './store';

export const usersSlice = createSlice({
  name: '@@USERS',
  initialState: UsersStore.empty(),

  reducers: (create) => ({
    putAll: create.reducer(
      (state: UsersStore, { payload: users }: PayloadAction<User[]>) =>
        UsersStore.putAll(users)(),
    ),

    added: create.reducer(
      (state: UsersStore, { payload: user }: PayloadAction<User>) =>
        UsersStore.added(user)(state),
    ),

    addedAll: create.reducer(
      (state: UsersStore, { payload: users }: PayloadAction<User[]>) =>
        UsersStore.addedAll(users)(state),
    ),
  }),
});
